import { usePaymentContext } from '../PaymentContext';
import { useNewCardForm } from './useNewCardForm';
import { useSelectCardForm } from './useSelectCardForm';
import { PaymentFormData } from '../types/PaymentFormData';
import { ISelectCardFormData } from '../types/ISelectCardFormData';
import { UseFormReturn } from 'react-hook-form';

export function usePaymentForm(
	selectCardFormDefaultValues?: ISelectCardFormData,
) {
	const { newCard } = usePaymentContext();
	const newCardForm = useNewCardForm();
	const selectCardForm = useSelectCardForm(selectCardFormDefaultValues);

	// we need to cast the return value to make this work with the FormProvider
	return (
		newCard ? newCardForm : selectCardForm
	) as UseFormReturn<PaymentFormData>;
}
